{
  "views": {
    "today": "Hoy",
    "day": "Día",
    "threeDay": "3 días",
    "week": "Semana",
    "month": "Mes",
    "prevPeriodAriaLabel": "Periodo anterior",
    "nextPeriodAriaLabel": "Periodo siguiente",
    "filterPlaceholder": "filtrar evento",
    "filterAriaLabel": "Filtrar evento"
  },
  "timeAreas": {
    "button": "Áreas de tiempo",
    "edit": "Editar",
    "backAriaLabel": "Volver a la lista de áreas",
    "nameAriaLabel": "Nombre del área de tiempo",
    "startTimeAriaLabel": "Hora de inicio, {{day}}",
    "endTimeAriaLabel": "Hora de fin, {{day}}",
    "notAvailable": "No disponible",
    "disableDay": "Desactivar día",
    "enableDay": "Activar día",
    "disableDayAriaLabel": "Desactivar {{day}}",
    "enableDayAriaLabel": "Activar {{day}}",
    "days": {
      "mon": "Lun",
      "tue": "Mar",
      "wed": "Mié",
      "thu": "Jue",
      "fri": "Vie",
      "sat": "Sáb",
      "sun": "Dom"
    },
    "defaults": {
      "work": "Trabajo",
      "appointments": "Citas", 
      "exercise": "Ejercicio"
    }
  },
  "recurrenceModal": {
    "title": "Evento Recurrente",
    "question": "¿Quieres aplicar los cambios solo a este evento o a la serie completa?",
    "onlyThisEvent": "Solo este evento",
    "allEvents": "Todos los eventos",
    "cancel": "Cancelar"
  },
  "toast": {
    "eventUpdated": "Evento actualizado.",
    "errorSavingTime": "Error al guardar el tiempo",
    "networkErrorSaving": "Error de red al guardar",
    "areaUpdated": "Área actualizada.",
    "errorSavingArea": "Error al guardar el área",
    "networkError": "Error de red",
    "eventMoved": "Evento movido.",
    "errorMoving": "Error al mover",
    "networkErrorMoving": "Error de red al mover"
  },
  "sidePanel": {
    "tabs": {
      "settings": "Configuración",
      "activities": "Actividad"
    },
    "filterByPerson": "Filtrar por persona",
    "searchPersonPlaceholder": "Buscar persona...",
    "selectAll": "Seleccionar todos",
    "deselectAll": "Deseleccionar todos",
    "noUsersFound": "No se encontraron usuarios",
    "noUserSelected": "Ningún usuario seleccionado",
    "myCalendars": "Mis Calendarios",
    "doubleClickToEdit": "Doble click para editar",
    "openPublicCalendly": "Abrir Calendly público",
    "calendlyWork": "Calendly (trabajo)",
    "copyLink": "Copiar link",
    "noRecentActivities": "No hay actividades recientes",
    "newCalendarDefaultName": "Nuevo Calendario"
  },
  "calendarEditor": {
    "title": "Editar Calendario",
    "nameLabel": "Nombre del Calendario",
    "timezoneLabel": "Zona Horaria",
    "ownerLabel": "Propietario",
    "ownerTag": "(Propietario)",
    "defaultOwnerName": "Tú",
    "sharedWithLabel": "Compartido con",
    "invitePlaceholder": "Invitar usuarios...",
    "noUsersFound": "No se encontraron usuarios",
    "notSharedYet": "No compartido con nadie aún.",
    "permissionsNote": "Los usuarios con acceso pueden ver y editar eventos en este calendario.",
    "protectWithPassword": "Proteger con contraseña",
    "share": "Compartir",
    "dataAndRecordings": "Datos y grabaciones",
    "confirmDelete": "¿Eliminar definitivamente?",
    "cancel": "Cancelar",
    "yesDelete": "Sí, eliminar",
    "deleteCalendar": "Eliminar calendario"
  },
  "eventCard": {
    "untitled": "Evento sin título"
  },
  "eventModal": {
    "editTitle": "Editar evento",
    "createTitle": "Crear evento",
    "titlePlaceholder": "Agregar título",
    "start": "Inicio",
    "end": "Fin",
    "loadingCalendars": "Cargando calendarios...",
    "organizerCalendar": "Calendario del Organizador",
    "addGuestsPlaceholder": "Agregar invitados",
    "organizerTag": "(Organizador)",
    "addGoogleMeet": "Agregar videollamada de Google Meet",
    "addLocationPlaceholder": "Agregar ubicación",
    "addDescriptionPlaceholder": "Agregar descripción",
    "visibility": {
      "default": "Visibilidad predeterminada",
      "private": "Privado",
      "public": "Público"
    },
    "recurringButton": "Evento recurrente",
    "recurrence": {
      "daily": "Diario",
      "weekly": "Semanal",
      "monthly": "Mensual",
      "yearly": "Anual",
      "weekDayLetters": ["L", "M", "X", "J", "V", "S", "D"]
    },
    "moreOptions": "Más opciones",
    "deleteEventTitle": "Eliminar evento",
    "declineInvitationTitle": "Rechazar invitación",
    "declineButton": "No aceptar",
    "confirmDeclineQuestion": "¿Está seguro de no aceptar?",
    "yes": "Sí",
    "cancel": "Cancelar",
    "save": "Guardar"
  }
}
